import React, {Component, Fragment} from 'react';
import Canvas from './Canvas'
import cvData from './cvData'
import HeaderList from './HeaderList'
import CanvasContext from './CanvasContext'
import leftArrow from './leftarrowIcon.svg'
import saveIcon from './saveIcon.png'
import discardIcon from './discardIcon.png'
import {firebaseActioner, auth} from '../firebase/firebase'
import trashIcon from './trashIcon.png';
import editIcon from './editIcon.png';
import HeaderForm1 from './HeaderForm1'

import {
    BrowserRouter as Router,
    Route,
    Link,
    withRouter
  } from 'react-router-dom';
  
class EditorCV extends Component {
    constructor(props) {
        super(props);
        this.state = {
            cvData: new cvData(),
            Canvas: new Canvas(), //to nie musi byc w state
            listOfExistedElements: [],
            saveButtonIsActive: false
            };
        this.documentID = this.props.documentID
        this.markBorderInElementsInCanvasPage = this.markBorderInElementsInCanvasPage.bind(this);
        this.ClearAdditionalCanvasLayer = this.ClearAdditionalCanvasLayer.bind(this);
        this.setSaveButtonAsActive = this.setSaveButtonAsActive.bind(this);
        this.setSaveButtonAsInactive = this.setSaveButtonAsInactive.bind(this);
        this.Navbar = this.Navbar.bind(this);
        this.AddNewElementToRawData = this.AddNewElementToRawData.bind(this);
        this.editElement = this.editElement.bind(this);
    }

    uploadRawData()
    {
        var docRef = firebaseActioner.collection('Users').doc(auth.currentUser.uid).collection('projects').doc(this.documentID);
        let project = this.state.cvData.rawData.project;
        docRef.get().then(function(doc) {
            if (doc.exists) {
                docRef.update(
                { 
                    project
                })
            } else {
                 console.log("No such document!");
            }
            }).catch(function(error) {
            console.log("Error getting document:", error);
        })  
    }

    setSaveButtonAsActive()
    {
        this.setState({saveButtonIsActive: true});
    }

    setSaveButtonAsInactive()
    {
        this.setState({saveButtonIsActive: false});
    }

    Navbar(linkTo)
    {
        let saveButton;
        if(this.state.saveButtonIsActive)
        {
            saveButton = <button type="button" class="btn btn-outline-success float-right" onClick={() => this.uploadRawData()}>
            <img className="img-fluid d-inline-block align-top " src={saveIcon} width="25" height="25" alt=""></img>
                    </button>
        }
        else
        {
            saveButton = <button type="button" class="btn btn-outline-success float-right disabled" >
                    <img className="img-fluid d-inline-block align-top " src={saveIcon} width="25" height="25" alt=""></img>
                </button>
        }
     return(   
            <div class="card">
            <div class="card-body">
                <Link to={linkTo}>
                    <button type="button" class="btn btn-outline-success">
                     <img className="img-fluid d-inline-block align-top" src={leftArrow} width="25" height="25" alt=""></img>
                   </button>
                </Link>
                {saveButton}
                <button type="button" class="btn btn-outline-success float-right" >
                    <img className="img-fluid d-inline-block align-top" src={discardIcon} width="25" height="25" alt=""></img>
                </button>
            </div>
            </div>
     )
    }

    markBorderInElementsInCanvasPage(index, posTop, posDown)
    {
        this.state.Canvas.DrawBorderOfElement(index, posTop, posDown);
    }

    ClearAdditionalCanvasLayer()
    {
        this.state.Canvas.ClearAdditionalCanvasLayer();
    }

    deleteElement(index)
    {
        console.log("Before delete", this.state.cvData.rawData.project);
        this.state.cvData.rawData.project.splice(index,1);
        this.state.Canvas.DrawData(this.state.cvData.rawData);
        this.GetListOfExistedElements(this.state.cvData.rawData);
        this.setSaveButtonAsActive();
        console.log("After delete", this.state.cvData.rawData.project);
    }

    EditElement(index)
    {
        let id = 1;//this.state.cvData.rawData.project[0];
        if(!this.state.cvData.rawData) return(<div>Loading....</div>)
        console.log("this.state.cvData.rawData", this.state.cvData.rawData);
       // console.log("this.state.cvData.rawData.project[index]", this.state.cvData.rawData.project[index]);
        if(id === "h01")
        {
            return(<HeaderForm1 documentID={this.documentID}/>)
        }
        else
        {
            return(<HeaderForm1 documentID={this.documentID} project={this.state.cvData.rawData.project[index]} index={index}/>)
        }
    }

    DrawGUI()
    {        
        var divStyle = {
            background: "#D3D9DA"
          };
        
        const data = this.state.listOfExistedElements.map((dat,index) => 
        {
            return (<button key={index} type="button" class="btn  btn-light btn-lg btn-block" 
                onMouseEnter={() => this.markBorderInElementsInCanvasPage(index, dat.posTop, dat.posDown)}
                onMouseLeave={this.ClearAdditionalCanvasLayer}>
                    {dat.type}
                    <Link to={`/dashboard/${this.documentID}/edit/${index}`}>
                    <button type="button" class="btn btn-outline-success ">
                        <img className="img-fluid d-inline-block align-top" src={editIcon} width="25" height="25" alt="" ></img>
                    </button>
                    </Link>
                    <button type="button" class="btn btn-outline-success " onClick={() => this.deleteElement(index)} >
                        <img className="img-fluid d-inline-block align-top" src={trashIcon} width="25" height="25" alt="" ></img>
                    </button>
                </button>)
        });

        let home = () =>
            <div class="flex-fill flex-column align-items-start justify-content-center">
            {this.Navbar("/dashboard")}   
            <div class="card text-center">
                <div class="card-body " style={divStyle}><h5 class="card-title">Existed elements</h5></div>
                {data}
            </div>  
            <div class="card text-center">
                <div class="card-body " style={divStyle}><h5 class="card-title">Add new element</h5></div>
            </div>   
                    
            <Link to={`/dashboard/${this.documentID}/addheader`}><button type="button" class="btn btn-outline-success btn-lg btn-block" >Header</button></Link>
            <button type="button" class="btn btn-outline-success btn-lg btn-block" >Education</button>
            <button type="button" class="btn btn-outline-success btn-lg btn-block" >Experience</button>
            <button type="button" class="btn btn-outline-success btn-lg btn-block" >Hobby</button>
            <button type="button" class="btn btn-outline-success btn-lg btn-block" >Skills</button>
            </div>

    return(
        <Fragment>
          <Route exact path={`/dashboard/${this.documentID}`} component={home} />
          <Route path={`/dashboard/${this.documentID}/addheader`} component={() => <HeaderList documentID={this.documentID}/>} />
          <Route path={`/dashboard/${this.documentID}/edit/:index`} component={ (props) => this.EditElement(props.match.params.index) } />
        </Fragment>
      )
    }

   
    GetListOfExistedElements(rawData)
    {
        var setState = this.setState.bind(this);
        if (rawData.project.length > 0) {
            let Elements=[];
            let absolutePositionOfElement = 0;
            rawData.project.forEach(element => {
                Elements.push({type: element.type, posTop: absolutePositionOfElement, posDown: absolutePositionOfElement + element.height});
                absolutePositionOfElement += element.height;
            });
            setState({listOfExistedElements: Elements});
        } else {
                console.log("No such document!");
        }
    }

    GetDataFromDataBaseToTemporaryDataModel(documentID)
    {
        console.log("GetDataFromDataBaseToTemporaryDataModel()");
        var docRef = firebaseActioner.collection('Users').doc(auth.currentUser.uid).collection('projects').doc(documentID);
        var setState = this.setState.bind(this);
        let cvDataCopy = this.state.cvData;
        docRef.get().then(function(doc) {
        if (doc.exists) {
            cvDataCopy.rawData = doc.data()
            setState({cvData: cvDataCopy});
        } else {
                // doc.data() will be undefined in this case
            console.log("No such document!");
        }
        }).then(
           () => this.state.Canvas.DrawData(this.state.cvData.rawData)        
        ).then(() => this.GetListOfExistedElements(this.state.cvData.rawData))
        .catch(function(error) {
        console.log("Error getting document:", error);
        })
    }

    editElement(index, elementName, name, surname, age)
    {
        this.state.cvData.ChangeElementInRawData(index, elementName, name, surname, age);
        this.state.Canvas.DrawData(this.state.cvData.rawData);
        this.GetListOfExistedElements(this.state.cvData.rawData);
        this.setSaveButtonAsActive();
    }

    AddNewElementToRawData(elementName, name, surname, age)
    {
      this.state.cvData.AddNewElementToRawData(elementName, name, surname, age);
      this.state.Canvas.DrawData(this.state.cvData.rawData);
      this.GetListOfExistedElements(this.state.cvData.rawData);
      this.setSaveButtonAsActive();
    }

    componentDidMount()
    {
        this.GetDataFromDataBaseToTemporaryDataModel(this.documentID);
    }

    render() {
        return (
            <div class="d-flex h-100">
            <CanvasContext.Provider value={
                {AddNewElementToRawData : this.AddNewElementToRawData,
                editElement: this.editElement,
                Navbar : this.Navbar
                 }}>
                {this.DrawGUI()}
            </CanvasContext.Provider>
                {this.state.Canvas.CanvasPage()}
            </div>
        );
      }
}

    export default (EditorCV)